module.exports = __webpack_public_path__ + "media/site/images/team/alek-bd5ac8c210d6a5c4d7da63e0a5bc86ca.png";